export default __webpack_public_path__ + "static/media/GMT.a84a814a.svg";